export default __webpack_public_path__ + "static/media/medinova.7129a1ca.jpeg";